<template>
  <section id="services" class="services">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">服务项目</h2>
        <p class="section-subtitle">我们提供全方位的数字化解决方案，助力企业转型升级</p>
      </div>
      <div class="services-grid">
        <div class="service-card">
          <div class="service-icon">🚀</div>
          <h3 class="service-title">技术服务与开发</h3>
          <p class="service-description">
            包括技术咨询、技术交流、技术转让、技术推广、技术开发等一站式技术服务，为企业提供定制化的技术解决方案。
          </p>
        </div>

        <div class="service-card">
          <div class="service-icon">📊</div>
          <h3 class="service-title">大数据与数字技术</h3>
          <p class="service-description">
            专业的大数据服务与数字技术服务，帮助企业构建数据驱动决策体系，实现数据资产的价值最大化。
          </p>
        </div>
        <div class="service-card">
          <div class="service-icon">🔍</div>
          <h3 class="service-title">数据处理与分析</h3>
          <p class="service-description">
            提供高效、安全的数据处理服务，包括数据清洗、分析、可视化等，为企业提供精准的数据洞察。
          </p>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppServices'
};
</script>

<style scoped>
.services {
  padding: 5rem 2rem;
  background-color: #ffffff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1E5AA8;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2.5rem;
}

.service-card {
  background: #f8fafc;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(30, 90, 168, 0.15);
  border-color: #1E5AA8;
}

.service-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
}

.service-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1E5AA8;
  margin-bottom: 1rem;
}

.service-description {
  font-size: 1rem;
  line-height: 1.7;
  color: #555;
  flex-grow: 1;
}

@media (max-width: 768px) {
  .services {
    padding: 3rem 1.5rem;
  }
  .services-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  .service-card {
    padding: 2rem 1.5rem;
  }
}
</style>
